import { CustomContext } from './configuration.model';

import { Product } from '@api/catalog/products/products.models';
import { CommonWindow } from '@core/domain/models/common-window.model';
import { PublicUser } from '@features/user';
import { EventFrom } from '@shared/analytics/COMMON/models/analytics-common.models';
/* eslint-disable no-secrets/no-secrets */

export interface GA4ContextGroup {
    page_location: string;
    page_referrer?: string;
    page_title: string;
    im_page_section: string;
    im_page_type: string;
    im_page_title: string;
    im_language: string;
    im_platform: string;
    im_local_store_id: string;
    im_store_status: string;
    im_step: string;
    im_user_email_sha256: string;
    user_id: string;
    im_physical_store: string;
    im_product_section: string;
    im_product_family: string;
    im_product_subfamily: string;
    im_user_logged: string;
    im_user_loyalty: string;
    im_user_quick_buy: string;
    im_user_profile_status: string;
}

export type PageSectionValue =
    'acceso'
    | 'ayuda'
    | 'catalogo'
    | 'checkout'
    | 'corporativo'
    | 'entrada'
    | 'error'
    | 'localizador_pedido'
    | 'localizador_tiendas'
    | 'perfil_usuario';

export type PageType =
    'Itx404ErrorPage'
    | 'Itx410ErrorPage'
    | 'ItxAngularAuthenticationConfirmationPage'
    | 'ItxAngularAuthenticationPage'
    | 'ItxAngularAuthenticationRecoveryPage'
    | 'ItxAngularAuthenticationRegisterPage'
    | 'ItxAngularContactPage'
    | 'ItxAngularGiftCardActivationPage'
    | 'ItxAngularGiftCardBalancePage'
    | 'ItxAngularGiftCardPage'
    | 'ItxAngularLookbookPage'
    | 'ItxAngularOrderStatus'
    | 'ItxAngularShopcartPage'
    | 'ItxAngularStoreDetailLocatorPage'
    | 'ItxAngularStoreLocatorPage'
    | 'ItxAngularTransactionCancelation'
    | 'ItxAngularWishlistPage'
    | 'ItxCategoryPage'
    | 'ItxCheckoutAuthPage'
    | 'ItxCheckoutPage'
    | 'ItxCheckoutPaymentPage'
    | 'ItxCheckoutRepaymentPage'
    | 'ItxCheckoutShippingDeliveryAddressPage'
    | 'ItxCheckoutShippingDeliveryPage'
    | 'ItxCheckoutShippingDeliverySummaryPage'
    | 'ItxCheckoutShippingDropPointPage'
    | 'ItxCheckoutShippingDropPointSummaryPage'
    | 'ItxCheckoutShippingPage'
    | 'ItxCheckoutShippingStorePage'
    | 'ItxCheckoutShippingStoreSummaryPage'
    | 'ItxCheckoutSummaryPage'
    | 'ItxHelpPage'
    | 'ItxHomeBgPage'
    | 'ItxHomeMenPage'
    | 'ItxHomePage'
    | 'ItxHomeWomenPage'
    | 'ItxMassimoDuttiFeelPage'
    | 'ItxMyAccountAccessDataPage'
    | 'ItxMyAccountAddressListPage'
    | 'ItxMyAccountCardsPage'
    | 'ItxMyAccountDetailsPage'
    | 'ItxMyAccountFeelBirthdayGiftPage'
    | 'ItxMyAccountFeelCollectionsPage'
    | 'ItxMyAccountFeelExperiencesPage'
    | 'ItxMyAccountFeelGiftingPage'
    | 'ItxMyAccountFeelActivationPage'
    | 'ItxMyAccountFeelBenefitsPage'
    | 'ItxMyAccountFeelHistoryPage'
    | 'ItxMyAccountFeelHowItWorksPage'
    | 'ItxMyAccountFeelPage'
    | 'ItxMyAccountFeelPaperlessPage'
    | 'ItxMyAccountFeelPersonalTailorPage'
    | 'ItxMyAccountFeelPromotionsPage'
    | 'ItxMyAccountFeelStyleAdvisorPage'
    | 'ItxMyAccountFeelWhatsappPage'
    | 'ItxMyAccountMenuPage'
    | 'ItxMyAccountNewsletterPage'
    | 'ItxMyAccountOrdersPage'
    | 'ItxMyAccountPage'
    | 'ItxMyAccountReturnsPage'
    | 'ItxMyAccountSponsorshipPage'
    | 'ItxNewsletterPage'
    | 'ItxOrderConfirmationPage'
    | 'ItxProductPage'
    | 'ItxWorldWidePage';

// TODO ECOMDUTI-22226 Revisar anotaciones de dudas
export type PageTypeValue =
    '<origen_popup>'
    | '404'
    | '410'
    | 'acceso' // NOTE: perfil_usuario - acceso - login ok para cambio de page ItxAngularAuthenticationPage en el nuevo login (PREPRU)
    // NOTE: checkout - acceso - login preguntado a JH para unificarlo de acuerdo a la nueva lógica del login
    | 'buscador'
    | 'campana' // NOTE: Pendiente revisión con Improving
    | 'cesta'
    | 'compra_rapida'
    | 'confirmacion' // NOTE: Página legacy (imposible de resolver actualmente, no se carga el modulo de angular)
    | 'contacto'
    | 'curalate' // NOTE: Solicitar url de ejemplo
    | 'datos_acceso'
    | 'datos_pago'
    | 'datos_personales'
    | 'desfile' // NOTE: Pendiente revisión con Improving por ser una página usada de forma esporádica no reutilizable
    | 'devolucion'
    | 'direccion/formulario'
    | 'direccion/lista'
    | 'disponibilidad_en_tienda'
    | 'editorial' // NOTE: Pendiente revisión con Improving por gestionarse como lookbook a través del cms
    | 'empresa'
    | 'envio'
    | 'ficha_bundle'
    | 'ficha_look' // NOTE: Pendiente revisión con Improving
    | 'ficha_producto'
    | 'ficha_tienda'
    | 'fidelizacion'
    | 'gift_card' // NOTE: Se añaden pageviews para la vista principal, balance y activación. Los demás pageviews han cambiado en la migración de la gift card (darle una vuelta)
    | 'guia_compra' // NOTE: Pendiente respuesta JH
    | 'guia_tallas'
    | 'home'
    | 'landing_membergetmember'
    | 'landing' // NOTE: Pendiente revisión con Improving por ser una página genérica de cms (Alexander: Esto habría que diferenciarlas como se hace con landing_membergetmember, obteniendo el slug de la url que llega por cms. Ejemplo => https://www.massimodutti.com/us/page/intro-member o https://www.massimodutti.com/us/member-get-member?sponsorcode="XXXXXXXXX")
    | 'libro_direcciones'
    | 'lista_productos' // NOTE: JH: Este lo vamos a tener cuando se desarolle el click&collect (aún no está desarrollado)
    | 'localizador_droppoint/localizar/lista'
    | 'localizador_tiendas/localizar/lista'
    | 'localizar_lista' // NOTE: JH: Este lo vamos a tener cuando se desarolle el click&collect (aún no está desarrollado)
    | 'localizar'
    | 'login'
    | 'lookbook'
    | 'menu_usuario'
    | 'metodo_devolucion'
    | 'microsite' // NOTE: (1)- microsite con cms ej:/es/microsite/liveshopping-n3938 (2)- microsite externo Solicitar página ejemplo a Content
    | 'minicesta'
    | 'miniwishlist'
    | 'newsletter'
    | 'pagina_corte' // NOTE: Solicitar página ejemplo Oriol
    | 'pago'
    | 'parrilla'
    | 'pedidos_invitado' // NOTE: JH: Efectivamente, aunque alguna vez aplicó, por lo que lo dejo en la guía por si se quiere implementar más adelante. No tienes que implementarlo si no está activo actualmente.
    | 'pedidos_realizados'
    | 'preguntas_frecuentes'
    | 'recomendador_tallas'
    | 'recuperar_contrasena'
    | 'registro'
    | 'repago' // NOTE: Solicitar ejemplo Oriol
    | 'reserva_en_tienda' // solo en apps
    | 'resumen_compra'
    | 'resumen/domicilio'
    | 'resumen/recogida_droppoint'
    | 'perfil_usuario/pedidos_realizados/cambios_gratuitos_tienda'
    | 'resumen/recogida_tienda'
    | 'seguimiento' // NOTE: Página legacy (ver default.layout.router.ts)
    | 'sponsorship'
    | 'subhome' // NOTE: JH: no estoy seguro, pero quizás pueda aplicar en un futuro, por lo que lo conservamos en la guía.
    | 'tienda_virtual' // NOTE: Preguntar a Oriol
    | 'tiendas_favoritas' // NOTE: JH: esto creo que no aplica, pero lo dejamos en la web por si acaso se activa
    | 'transaction_cancelation'
    | 'thenow' // NOT: No listado en la guía
    | 'video_devoluciones' // NOTE: Página de categoría
    | 'video_personalizado' // NOTE: Preguntar a Oriol
    | 'vista_rapida_bundle'
    | 'vista_rapida_look' // No existe en la web
    | 'vista_rapida_producto_bundle' // NOTE: ok => Ejemplo producto bundle en /mc/andrew/3-n1842
    | 'vista_rapida_producto_cross'
    | 'vista_rapida_producto'
    | 'wallet' // NOTE: JH: Lo de Wallet, está en Apps. Entiendo que quizás lo pudieron plantear para WR en algún momento. Por eso no está presente en la guía, pero si está en el cuadro resumen de page type. Pero lo elimino de este cuadro resumen, ya que como bien dices, no está en la gía de WR.
    | 'wishlist'
    | 'worldwide';

export type PageTitleValue =
    'activacion'
    | 'baja'
    | 'colecciones_especiales'
    | 'confirmacion'
    | 'consulta_saldo'
    | 'consulta_stock'
    | 'contenido_exclusivo'
    | 'datos_envio'
    | 'datos_pago'
    | 'datos_pedido'
    | 'detalles_unicos'
    | 'direccion/formulario'
    | 'direccion/lista'
    | 'experiencias_exclusivas'
    | 'fidelizacion/beneficios'
    | 'inicio'
    | 'intro_member'
    | 'lista_articulos'
    | 'lista_de_productos'
    | 'lista'
    | 'localizador_droppoint/localizar/lista'
    | 'localizador_tiendas/localizar/lista'
    | 'localizar_pedido'
    | 'login_facebook'
    | 'login'
    | 'mi_cuenta'
    | 'newsletter'
    | 'pagina_inicio_beauty'
    | 'pagina_inicio_men'
    | 'pagina_inicio_women'
    | 'paperless'
    | 'promociones'
    | 'recuperar_contrasena'
    | 'registro'
    | 'registro/confirmacion'
    | 'reserva_cita'
    | 'resumen/domicilio'
    | 'resumen/recogida_droppoint'
    | 'resumen/recogida_tienda'
    | 'seleccion_tienda_e_idioma_lista'
    | 'seleccion_tienda_e_idioma'
    | 'sin_resultados'
    | 'solicitar_recogida'
    | 'vacia'
    | 'vista_rapida_producto_cross'
    | 'vista_rapida_producto'
    | 'whatsapp';

export type RelatedKind =
    'relacionados'
    | 'ultimosvistos';

export type RelatedPlace =
    'buscador'
    | 'cesta'
    | 'cesta/compramastarde'
    | 'fichaproducto'
    | 'fichaproducto/popup/addtocart'
    | 'fichaproducto/popup/bs'
    | 'giftcard'
    | 'home'
    | 'parrilla'
    | 'parrilla/popup/addtocart'
    | 'parrilla/popup/bs';

export type RelatedAlgorithm =
    'cart_yoda' | 'completatulook' | 'completatulook_yoda' | 'compraconjunta' | 'oyml' | 'similares' | 'similares_yoda' | 'tickets' | 'topventas';

export enum StoreStatusValue {
    open = 'abierta',
    close = 'cerrada',
}

export interface GA4ContextValues {
    user: PublicUser;
    customContext: CustomContext;
    eventFrom: EventFrom;
    document: Document;
    window: CommonWindow;
}

export interface ProductContext extends Product {
    isCart?: boolean;
}

export enum UserLogguedString {
    logueado = 'logueado',
    noLogueado = 'no_logueado',
}

export enum YesOrNoTypeString {
    si = 'si',
    no = 'no',
}

export enum UserProfileStatus {
    guest = 'guest',
    semiguest = 'semiguest',
    registered = 'registered',
    wallet = 'wallet',
    walletShipping = 'wallet_shipping',
}
